import React from 'react'
import { toast } from "react-toastify";
const useToastify = () => {
    const notify = (msg, type) => {

        
        toast(msg, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            theme: "colored",
            type: type,
            autoClose: 9000,
            closeOnClick: false
        });


    };

    
    return {
        notify
    }

}

export default useToastify